<template>
  <div class="layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Layout'
};
</script>

<style lang="less" scoped>
.layout{
  width: 100%;
  height: calc(100vh - 160px);
  box-sizing: border-box;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
  overflow: auto;
  .layout {
    box-shadow: none;
    padding: 16px 32px;
    box-sizing: border-box;
    margin-top: -15px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout.vue